export default __webpack_public_path__ + "static/media/Envelope.d94e898b.png";